import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AuthService } from 'src/app/core/authentication/auth.service';
import { UserInfo } from 'src/app/core/authentication/UserInfo';

@Component({
  selector: 'mandates-main-toolbar',
  templateUrl: './main-toolbar.component.html',
  styleUrls: ['./main-toolbar.component.scss'],
})
export class MainToolbarComponent implements OnInit, OnDestroy {
  userInfo: UserInfo | undefined;

  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.userInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((userInfo) => (this.userInfo = userInfo));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['logout']);
  }

  get userInfo$(): BehaviorSubject<UserInfo | undefined> {
    return this.authService.userInfo$;
  }
}
